export const AttachmentsConfig = {
  TOOLTIP_DELAY: 1000,
};
